export default {
  /** ---------接口配置模块--------- */
  /** 登录权限相关 */
  getUserInfo: '/gateway/api/user/context/',
  logout: '/gateway/api/user/logout/',
  // 获取开放场景列表
  getOpenSceneList: '/gateway/api/open_scene/get/',
  getTeamList: '/gateway/api/team/get/',
  // 图片上传
  uploadImage: '/gateway/api/common/file/upload/',
};
